export const getCaptchaTheme = (
  theme: 'light' | 'dark' | 'auto' | undefined,
) => {
  if (theme === 'auto') {
    if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  }
  return theme || 'light';
};
